import { indexOf } from 'lodash';

export const orderByPinnedEventIds = (pinnedEventIds) => (id) => {
  const index = indexOf(pinnedEventIds, id);
  if (index === -1) return Number.MAX_SAFE_INTEGER;
  return index;
};
